export class SummaryReportModel {
    constructor() {
        this.assetCategoryId = "";
        this.assetCategoryName = "";
    }
}
export default class SummaryReport extends SummaryReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
